const settingsLinks = (heroku, digitalOcean, invoiced) => {
  const links = [
    {
      key: 'settings-account',
      href: '/account',
      label: 'Account',
    },
    {
      key: 'settings-profile',
      href: '/account/profile',
      label: 'Profile',
    },
    {
      key: 'settings-viewer',
      href: '/account/viewer',
      label: 'Event Viewer',
    },
  ];

  // neither Heroku or DigitalOcean manager Members in Papertrail
  if (!heroku && !digitalOcean) {
    links.push({
      key: 'settings-members',
      href: '/account/members',
      label: 'Members',
    });
  }

   links.push({
    key: 'settings-archives',
    href: '/account/archives',
    label: 'Archives',
  });

  // both Heroku and DigitalOcean can see usage notifications
  if (heroku || digitalOcean) {
    links.push({
      key: 'settings-usage-notifications',
      href: '/account/usage-notifications',
      label: 'Usage Notifications',
    });
  }

  // we don't allow Heroku to control Log Destinations, but standard
  // accounts and DigitalOcean accounts can
  if (!heroku) {
    links.push({
      key: 'settings-log-destinations',
      href: '/account/destinations',
      label: 'Log Destinations',
    });
  }

  // only show payment for standard, non-invoiced accounts
  if (!heroku && !digitalOcean && !invoiced) {
    links.push({
      key: 'settings-payment',
      href: '/account/payment',
      label: 'Payment',
    });
  }

  links.push({
    key: 'settings-purge',
    href: '/account/purge-events',
    label: 'Purge Events',
  });

  return links;
};

export default (heroku, digitalOcean, invoiced, onChatClick, baseUrl, isAdmin) => {
  const navigation = [
    {
      key: 'dashboard',
      href: '/dashboard',
      label: 'Dashboard',
    },
    {
      key: 'events',
      href: '/events',
      label: 'Events',
    },
    {
      key: 'search_alerts',
      href: '/alerts',
      label: 'Alerts',
    },
    {
      key: 'settings',
      label: 'Settings',
      links: settingsLinks(heroku, digitalOcean, invoiced),
    },
    {
      key: 'support',
      label: 'Support',
      links: [
        {
          key: 'support-quick-start',
          href: '/start',
          label: 'Quick Start',
        },
        {
          key: 'support-docs',
          href: 'https://help.papertrailapp.com',
          label: 'Docs & Help',
          newTab: true,
        },
        {
          key: 'support-email',
          href: onChatClick ? undefined : 'mailto:technicalsupport@solarwinds.com',
          label: onChatClick ? 'Live Chat' : 'Ask Question',
          newTab: true,
          onClick: onChatClick,
        },
        {
          key: 'support-terms',
          href: '/info/terms',
          label: 'Terms',
          newTab: true,
        },
      ],
    },
  ];

  if (isAdmin) {
    navigation.push({
      key: 'admin',
      label: 'Admin',
      href: '/admin/dashboard'
    })
  }

  return navigation;
};
